<template>
    <div
        @click.capture="() => {}"
        class="widgets-checkbox"
    >
        <b-overlay
            :show="showOverlay"
        >
            <h4
                class="mb-2"
            >
                {{ $t('org.dashboard.Card list') }}
            </h4>
            <b-input-group>
                <b-input-group-prepend is-text>
                    <SVGWidgetSearchIcon/>
                </b-input-group-prepend>
                <b-form-input
                    class="search-input-space"
                    :placeholder="$t('v4.Search')"
                    v-model="searchValue"
                />
            </b-input-group>
            <div
                class="pt-1"
            >
                <b-form-checkbox-group
                    v-model="cardModels"
                    @input.capture="handleWidgetCardModel"
                >
                    <b-form-checkbox
                        class="d-block pt-1 pb-1"
                        v-for="(card, keys) in filterItems"
                        :key="keys"
                        :value="card.value"
                        inline
                    >
                        <span
                            class="font-medium-1 line-height-1"
                        >
                            {{ card.text }}
                        </span>
                    </b-form-checkbox>
                </b-form-checkbox-group>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import { computed, getCurrentInstance, ref, watch } from '@vue/composition-api'
import useWidget from '@/composables/useWidget'
import useDashboard from '@/composables/useDashboard'
import useDashboardHeader from '@/composables/useDashboardHeader'
import useDashboardRender from '@/composables/useDashboardRender'
import cardType from '../cardType'
import SVGWidgetSearchIcon from '@/assets/images/icons/widget-search.svg'

export default {
    components: {
        SVGWidgetSearchIcon
    },
    setup () {
        const vm = getCurrentInstance().proxy
        const {
            cardModels,
            widgetCardModel,
            handleWidgetCardModel
        } = useWidget()
        const { loadingStatus } = useDashboard()
        const { isEditMode } = useDashboardHeader()
        const { editDashboard } = useDashboardRender()
        const showOverlay = ref(false)
        const cardList = computed(() => [
            { value: cardType.CARD_TOTAL_COST, text: vm.$t('org.dashboard.Total Cost') },
            { value: cardType.CARD_DOWNLOAD, text: vm.$t('org.dashboard.Download invoice') },
            { value: cardType.CARD_MONTHS, text: vm.$t('org.dashboard.Monthly Cost') },
            { value: cardType.CARD_WEEKS, text: vm.$t('org.dashboard.Weekly Cost') },
            { value: cardType.CARD_DATES, text: vm.$t('org.dashboard.Daily Cost') },
            { value: cardType.CARD_PRODUCTS, text: vm.$t('org.dashboard.Cost by product') },
            { value: cardType.CARD_REGIONS, text: vm.$t('org.dashboard.Cost by region') },
            { value: cardType.CARD_BANNER, text: vm.$t('org.dashboard.Banner') },
            { value: cardType.CARD_BOARD, text: vm.$t('org.common.Notice') },
            { value: cardType.CARD_STATISTICS, text: vm.$t('org.dashboard.Account State') },
            { value: cardType.CARD_DATES_DETAIL, text: vm.$t('org.dashboard.Daily Detailed Cost') },
            { value: cardType.SUMMARY_CARD_SIDEBAR, text: vm.$t('org.dashboard.Old Sidebar') },
            { value: cardType.SUMMARY_CARD_PRODUCTS, text: vm.$t('org.dashboard.Old Cost by product') },
            { value: cardType.SUMMARY_CARD_REGIONS, text: vm.$t('org.dashboard.Old Cost by region') },
            { value: cardType.SUMMARY_CARD_DATES, text: vm.$t('org.dashboard.Old Daily Cost') },
            { value: cardType.SUMMARY_CARD_WEEKS, text: vm.$t('org.dashboard.Old Weekly Cost') }
        ])
        const searchValue = ref('')
        const filterItems = computed(() => searchValue.value ? cardList.value.filter(card => card.text.toLowerCase().indexOf(searchValue.value.toLowerCase()) > -1) : cardList.value)
        watch(loadingStatus, (value, oldValue) => {
            showOverlay.value = value
        }, {
            deep: true
        })
        watch(isEditMode, (value, oldValue) => {
            if (value) {
                searchValue.value = ''
                handleWidgetCardModel(editDashboard.value.map(item => item.i))
            }
        })
        watch(widgetCardModel, (value, oldValue) => {
            cardModels.value = value
        })
        return {
            showOverlay,
            searchValue,
            filterItems,
            cardModels,
            handleWidgetCardModel
        }
    }
}
</script>
<style>
.widgets-checkbox .custom-checkbox .custom-control-label::before,
.widgets-checkbox .custom-checkbox .custom-control-label::after,
.widgets-checkbox .custom-radio .custom-control-label::before,
.widgets-checkbox .custom-radio .custom-control-label::after {
    width: 20px !important;
    height: 20px !important;
    margin: 1rem 0;
}
.widgets-checkbox .form-control {
    border-left: none;
    height: 32px;
}
.widgets-checkbox .custom-control {
    padding-left: 3rem;
}
.widgets-checkbox {
    height: 32px !important;
}
.widgets-checkbox .input-group-text {
    padding: 5px 0 3px 8px;
}
.widgets-checkbox .search-input-space {
    padding: 8px 0 6px 7px;
    font-size: 15px;
    line-height: 0;
}
.search-input-space::placeholder {
    color: #D9D9D9;
}
</style>
